import { jsonMember, jsonObject } from 'typedjson';

@jsonObject
export class OrderItemRefundSummaryResponse {
  @jsonMember(Number)
  public readonly originalPrice!: number;

  @jsonMember(Number)
  public readonly refundedPrice!: number;

  @jsonMember(Number)
  public readonly currentPrice!: number;

  @jsonMember(Number)
  public readonly originalQuantity!: number;

  @jsonMember(Number)
  public readonly refundedQuantity!: number;

  @jsonMember(Number)
  public readonly currentQuantity!: number;

  @jsonMember(Boolean)
  public readonly fullyRefunded!: boolean;
}
